import { useEffect } from "react";
import { Input, Form, Select } from "antd";
import { getLangList } from '@/lib/i18n';
import { getOptionArray, selectFilterOption, modalFromLayout } from "@/lib/antdElementFunction";
import { RoleType, DepartmentType } from './types';

interface Props {
  form: any;
  info: RoleType;
  departmentArray: DepartmentType[];
  handleType: string;
}

function ModalRole(props: Props) {
  const { form, info, handleType, departmentArray } = props;
  const organizationT: any = getLangList("organization");

  useEffect(() => {
    const { departmentId, roleDesc } = info ?? {};

    handleType === 'update' && form.setFieldsValue({ departmentId, roleDesc });
  }, [form, info, handleType]);

  function getFormatDepartmentData() {
    return departmentArray.map((item: DepartmentType) => ({ label: item.departmentName, value: item.id }));
  };

  return (
    <Form
      className="admin-form"
      style={{ marginTop: 20 }}
      {...modalFromLayout}
      form={form}
    >
      <Form.Item
        label={organizationT.DEPARTMENT}
        name="departmentId"
        rules={[{ required: true }]}
      >
        <Select
          showSearch
          style={{ width: "100%" }}
          optionFilterProp="children"
          filterOption={(input: any, option: any) => selectFilterOption(input, option)}
        >
          {getOptionArray(getFormatDepartmentData())}
        </Select>
      </Form.Item>

      <Form.Item
        label={organizationT.ROLE}
        name="roleDesc"
        rules={[{ required: true }]}
      >
        <Input />
      </Form.Item>
    </Form >
  );
}

export default ModalRole;